<template>
  <div>
    <el-tree ref='refTree'
             :data="data"
             :props="defaultProps"
             :node-key="nodeKey"
             :check-strictly='strongReleave'
             @check='handleCheck'
             :default-checked-keys="defaultChecked"
             show-checkbox />
  </div>
</template>

<script>
import { json } from 'mathjs'
import { Tree } from './../../utils'
export default {
  name: 'TicTree',
  props: {
    // 数据集合
    datas: {
      default: () => {
        return {}
      },
      type: Object,
    },
    // 基础配置
    defaultProps: {
      default: () => {
        return {}
      },
      type: Object,
    },
    // 获取选中id对应的字段名
    nodeKey: {
      default: '',
      type: String,
    },
    // 父子是否强关联
    strongReleave: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      data: [],
      defaultChecked: [],
    }
  },
  mounted() {},
  methods: {
    handleCheck() {
      // 半选节点
      const halfNodes = this.$refs.refTree.getHalfCheckedNodes()
      // 全选节点
      const completeNodes = this.$refs.refTree.getCheckedNodes()
      this.$emit('emit:tree', {
        halfNodes,
        completeNodes,
      })
    },
    clearCheck() {
      this.$refs.refTree.setCheckedKeys([]) // 设置选中清空
      this.defaultChecked = []
    },
    init(treeDatas, activeDatas, defaultCheckedKeys) {
      console.log(treeDatas, activeDatas, defaultCheckedKeys)
      treeDatas.forEach((v) => {
        v.bu = String(v.bu)
        if (activeDatas.length) {
          v.disabled = true
          if (activeDatas.includes(v[this.nodeKey])) v.disabled = false
        } else {
          v.disabled = true
        }
      })
      this.data = Tree(treeDatas, 'bu', 'parentCode')
      this.data = JSON.parse(JSON.stringify(this.data))
      console.log(this.data)
      this.defaultChecked = defaultCheckedKeys
      setTimeout(() => {
        // // 根据全选节点推断是否禁用该节点
        // const completeNodes = this.data.activeDatas || []
        // // console.log('completeNodes', completeNodes)
        // this.data.forEach((v) => {
        //   // if (completeNodes.includes(String(v.bu))) v.disabled = false
        //   console.log(v.children.length && v.children.every(v => completeNodes.includes(v.bu)), '1111111111111')
        //   if (v.children.length && v.children.every(v => completeNodes.includes(v.bu))) {
        //     v.disabled = false
        //     v.children.forEach((v1) => {
        //       // if (completeNodes.includes(String(v1.bu))) v1.disabled = false
        //       console.log(v1.children.length && v1.children.every(v => completeNodes.includes(v.bu)), '222222222222222')
        //       if (v1.children.length && v1.children.every(v => completeNodes.includes(v.bu))) {
        //         v1.disabled = false
        //         // v1.children.forEach((v2) => {
        //         //   if (completeNodes.includes(String(v2.bu))) v2.disabled = false
        //         // })
        //       }
        //     })
        //   }
        // })
        // 根据全选节点推断取消禁用节点
        this.data.forEach((v) => {
          if (v.children.length) {
            if (v.children.every((v) => !v.disabled)) v.disabled = false
            v.children.forEach((v1) => {
              if (v1.children.length) {
                if (v1.children.every((v) => !v.disabled)) v1.disabled = false
              }
            })
          }
        })
        // 解决子节点取消禁用后。父节点还是禁用状态
        this.data.forEach((v) => {
          if (v.children.length) {
            if (v.children.every((v) => !v.disabled)) v.disabled = false
          }
        })
        this.handleCheck()
      }, 0)
    },
  },
  watch: {
    datas: {
      handler(nVal) {
        const copyDatas = JSON.parse(JSON.stringify(nVal))
        this.init(
          copyDatas.treeDatas,
          copyDatas.activeDatas,
          copyDatas.defaultCheckedKeys
        )
      },
      deep: true,
    },
  },
}
</script>
